<scope-theme></scope-theme>

@if (cultureCode) {
  <sss-navbar-header
    environment="{{ environmentName }}"
    data-html2canvas-ignore="true"
    culture="{{ cultureCode }}"
  >
    <sss-navbar-application-brand class="sss-navbar-separator">
      <span>{{ 'ServicePlanning' | translate }}</span>
      @if (hasNewFeatures) {
        <span class="new-updates-badge">{{ 'NewUpdates' | translate }}</span>
      }
    </sss-navbar-application-brand>

    <div class="sss-navbar-menu-divider"></div>

    @if (isLoggedIn) {
      <sss-navbar-header-navigation></sss-navbar-header-navigation>

      @if (cultureCode && isTokenDispatched) {
        <scope-guided-tour show-reset="true"></scope-guided-tour>
        <navbar-header-notifications
          id="notificationButton"
          label="{{ 'Aviseringar' | translate }}"
          heading="{{ 'Aviseringar' | translate }}"
          tabindex="0"
        >
          <notifications-container
            culturecode="{{ cultureCode }}"
            loggedin="true"
            environment="{{ environmentName }}"
            systemname="FmsServicePlanning"
          ></notifications-container>
        </navbar-header-notifications>
      }
    }

    <sss-navbar-help environment="{{ environmentName }}"></sss-navbar-help>

    @if (isLoggedIn) {
      <sss-navbar-app-launcher></sss-navbar-app-launcher>

      <sss-navbar-account>
        <!-- Privacy statement link, so the user can update cookies once set -->
        <li
          class="sss-navbar__list-group-item sss-navbar__dropdown-item"
          (click)="goToPrivacyPage()"
        >
          <span [translate]="'Gdpr_Integritetspolicy'"></span>
        </li>
      </sss-navbar-account>
    }

    <sss-navbar-brand></sss-navbar-brand>
  </sss-navbar-header>
}

@if (cultureCode) {
  <sss-navbar-side-menu collapsible="true" culture="{{ cultureCode }}">
    @for (navbarItem of navbarMenuItems; track navbarItem) {
      @if (navbarItem.isVisible) {
        <sss-navbar-menu-item
          class="nav-menu-item"
          icon="{{ navbarItem.icon }}"
          label="{{ navbarItem.label | translate }}"
          routerLinkActive="active"
          [class.highlighted]="navbarItem.isHighlighted"
          [ngClass]="navbarItem.highlightType"
        >
          @if (navbarItem.routerLink) {
            <a class="sss-navbar-menu-nav-link" [routerLink]="navbarItem.routerLink">
              {{ navbarItem.label | translate }}
            </a>
          } @else {
            <a class="sss-navbar-menu-nav-link" [href]="navbarItem.absoluteLink" target="_self">
              {{ navbarItem.label | translate }}
            </a>
          }

          @if (navbarItem.isHighlighted) {
            <span class="badge" [ngClass]="{ 'badge-count': navbarItem.badgeCount }">
              {{ navbarItem.badgeCount }}
            </span>
          }
        </sss-navbar-menu-item>
      }
    }

    @if (!isLoggedIn) {
      <sss-navbar-menu-item class="nav-menu-item preloader">
        <spinner-loader></spinner-loader>
      </sss-navbar-menu-item>
    }
  </sss-navbar-side-menu>
}

<main>
  <router-outlet></router-outlet>
</main>

<app-no-internet-toastr></app-no-internet-toastr>

@if (isLoggedIn) {
  <zendesk-widget
    launcher-position="bottom-right"
    [attr.keycloak-environment]="environmentName === 'prod' ? environmentName : 'preprod'"
    [attr.user-language]="cultureCode"
    [attr.auth-token]="authToken()"
  ></zendesk-widget>
}

@if (showCookieSettingsButton) {
  <div class="cookie-wrapper">
    <action-button
      (action)="openOneTrustModal()"
      [type]="ButtonType.SECONDARY"
      [size]="'sm'"
      [tdsIconName]="'cookie'"
    ></action-button>
  </div>
}

<modal-outlet />

<tooltip-outlet />

<toast-outlet />
